
import { Utilities } from "../../shared/utilities";

export function discardDraft(processId: number | undefined, redirectAfterDiscard?: boolean, isSubProcess?: boolean) {
    return async () => {
        try {
            if (processId === undefined) {
                return;
            }
            const id = await Utilities.postJsonAndParseResponse(`api/process/discard/${processId}`, null);
            if (redirectAfterDiscard) {
                const base = document.getElementsByTagName("base")[0].href;
                const firstPathPart = isSubProcess ? "SubProcess" : "Process";
                if (id != null) {
                    const newProcessUrl = `${base + firstPathPart}/Edit/${id}`;
                    setTimeout(() => window.location.href = newProcessUrl, 1000);
                } else {
                    setTimeout(() => window.location.href = `${base + firstPathPart}/List`, 1000);
                }
            } else {
                return id;
            }
        } catch (err) {
            Utilities.toastError(FRENDS.Localizations.Error_Generic + err);
        }
    };
}
